import React from 'react';
import Type from 'prop-types';
import { useField } from 'formik';
import InputMask from 'react-input-mask';
import { TextField } from '@material-ui/core';
import { ru } from 'locale';

const PhoneInput = ({ disabled, mask, maskPlaceholder, ...props }) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : '';

  return (
    <InputMask mask={mask} maskPlaceholder={maskPlaceholder} disabled={disabled} {...field}>
      <TextField {...props} error={!!errorText} helperText={errorText} />
    </InputMask>
  );
};

PhoneInput.propTypes = {
  name: Type.string,
  type: Type.string,
  label: Type.string,
  mask: Type.oneOfType([
    Type.string,
    Type.arrayOf(Type.oneOfType([Type.string, Type.instanceOf(RegExp)])),
  ]),
  maskPlaceholder: Type.string,
  disabled: Type.bool,
};

PhoneInput.defaultProps = {
  name: 'phone',
  type: 'tel',
  label: ru.phone,
  mask: '+7 999 999-99-99',
  maskPlaceholder: null,
  disabled: false,
};

export default PhoneInput;
